import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Tooltip from '@material-ui/core/Tooltip';

import style from './style';

function CardStats({...props}) {
  const {
    classes,
    value,
    description,
    borderTopColor,
  } = props;

  const tooltip = {
    classes: {
      tooltip: classes.cardStats__tooltip,
      popper: classes.cardStats__tooltipPopper,
    },
    title: value,
    placement: 'top',
  };

  return (
    <Card className={classes.cardStats}>
      <CardContent
        className={classNames(
          classes.cardStats__content,
          classes[`cardStats__borderTop_${borderTopColor}`],
        )}
      >
        <Tooltip
          open={false}
          classes={tooltip.classes}
          placement={tooltip.placement}
          title={tooltip.title}
        >
          <h2 className={classes.cardStats__value}>
            {value}
          </h2>
        </Tooltip>
        <p className={classes.cardStats__description}>
          {description}
        </p>
      </CardContent>
    </Card>
  );
}

CardStats.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.node,
  description: PropTypes.node,
  borderTopColor: PropTypes.oneOf([
    'green',
    'yellow',
    'primary',
    'red',
  ]),
};

CardStats.defaultProps = {
  value: '',
  description: '',
  borderTopColor: 'black',
};

export default withStyles(style)(CardStats);
